import { Typography } from "@mui/material";
import { IInvoiceDetail } from "models/IOrder";

interface IProps {
    invoiceDetail: IInvoiceDetail,
    variant: any,
}

const InvoiceDetailPart: React.FC<IProps> = ({ invoiceDetail, variant }: IProps) => {
    return <Typography variant={variant} textAlign="left">
        {invoiceDetail.part}
    </Typography>;
};

export default InvoiceDetailPart;